<template>
  <div class="form-group row">
    <label
      for="inputNumber"
      class="col-sm-2 col-form-label"
      >{{label}}</label>
    <div class="col-sm-10">
      <input
        v-model.number="number"
        class="form-control"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
        :min="0"
        type="number"
        id="inputNumber"
        />
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null
    },
    v: {
      type: Object,
      required: true
    },
    readonly: Boolean,
    label: String,
    placeholder: String
  },
  computed: {
    number: {
      get () {
        return this.value
      },
      set (value) {
        this.v.$touch()
        this.$emit('input', value)
      }
    }
  }
}
</script>
